module.exports = __webpack_public_path__ + "img/banner_pc_realme1.5eb9b67a.png";